import { Task } from '@/types';
import moment from 'moment';

export class TaskMutator {
  public static toTabular(task: Task, config: any): any {
    const tableConfig: any = {
      task_type: {
        value: task.type!.replace(/^\w/, (c) => c.toUpperCase()),
        property: 'task.type',
      },
      project_name: {
        value: task.project ? task.project.name : '',
        property: 'project_name',
      },
      site_name: {
        value: task.position && task.position.site ? task.position.site.name :
                task.device && task.device.site ? task.device.site.name : '',
        property: 'site_name',
      },
      location_name: {
        value: task.position && task.position.location ? task.position.location.name :
                task.device && task.device.location ? task.device.location.name : '',
        property: 'location_name',
      },
      device_name: {
        value: task.device ? task.device.device_id : '',
        property: 'task.device_id',
      },
      due_at: {
        value: task.due_at ? moment(task.due_at).format('DD MMM YYYY')  : '',
        property: 'task.due_at',
      },
      completed_at: {
        value: task.completed_at ? moment(task.completed_at).format('DD MMM YYYY HH:mm:ss') : '',
        property: 'task.completed_at',
      },
      completed_by: {
        value: task.completed_user ? `${task.completed_user.first_name} ${task.completed_user.last_name}` : '',
        property: 'task.completed_by_user_id',
        classes: 'capitalize',
      },
      created_at: {
        value: task.created_at ? moment(task.created_at).format('DD MMM YYYY HH:mm:ss') : '',
        property: 'task.created_at',
      },
      id: task.id,
    };
    if (config && config.exclude) {
      (config.exclude as string[]).forEach((value) => delete tableConfig[value]);
    }
    return tableConfig;
  }
}
